import e from "react";
const r = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 13", width: "8", height: "13" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement("path", { fillRule: "nonzero", d: "M7.60931572,7.41916201 L2.27599473,12.6191042 C2.01555089,12.8730347 1.67451464,13 1.33333025,13 C0.992145851,13 0.651109604,12.8730347 0.390665762,12.6191042 C-0.130221921,12.1116765 -0.130221921,11.2882079 0.390665762,10.7807802 L4.78117412,6.50007222 L0.390665762,2.21921979 C-0.130221921,1.71179209 -0.130221921,0.888323463 0.390665762,0.380895768 C0.911553445,-0.126965256 1.7552552,-0.126965256 2.27614288,0.380895768 L7.60946387,5.58083799 C8.1302034,6.08826569 8.1302034,6.91187876 7.60931572,7.41916201 Z", transform: "matrix(-1 0 0 1 8 0)" })
  )
);
r.displayName = "ChevronLeft8x13";
export {
  r as I
};
//# sourceMappingURL=ChevronLeft8x13-CHzitOe8.mjs.map
